import { render, staticRenderFns } from "./BookingRecap.vue?vue&type=template&id=d5e66e46&"
import script from "./BookingRecap.vue?vue&type=script&lang=js&"
export * from "./BookingRecap.vue?vue&type=script&lang=js&"
import style0 from "./BookingRecap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports